enum FiltersFieldSearchMode {
  TEXT = 'text',
  SELECT_FIELD = 'select-field',
  SELECT_FIELD_VALUE = 'select-field-value',
}

interface FiltersFieldInstance {
  selectField: (name: string) => void
  setItemForFilterField: (item: SelectionFilterField) => void
}

interface ControlBarInstance {
  filtersFieldRef?: FiltersFieldInstance
}

interface SimpleFilterFieldInstance<
  I extends Record<string, unknown> = Record<string, unknown>
> {
  autoSelectFilterFieldItem: () => void
  items: I[]
}

interface SelectionFilterField<F = string, V = unknown> {
  field: F
  text: string
  value: V
  searchText?: string
}

interface SimpleFilterField<
  N extends string = string,
  I extends Record<string, unknown> = Record<string, unknown>,
  IV extends keyof I = string,
  IT extends keyof I = string
> {
  name: N
  label: string
  itemValue?: IV
  itemText?: IT
  type?: undefined
  hasItemDivider?: boolean
  items?: I[]
  fetchItems?: (payload: { searchText: string }) => Promise<I[]>
  filterItem?: (payload: { item: I; searchText: string }) => boolean
  enterItem?: (payload: {
    items: I[]
    searchText: string
    filterFied: {
      name: N
      label: string
    }
    setItemForFilterField: (item: SelectionFilterField<N>) => void
  }) => boolean
}

interface DatepickerFilterField<N extends string = string> {
  name: N
  type: 'datepicker'
  label: string
}

type SortFieldValue = string | number | null

interface SortFieldItem {
  text: string
  value: SortFieldValue
}

interface SortFieldProps {
  value: SortFieldValue
  items: SortFieldItem[]
  onChangeValue: (value: SortFieldValue) => void
  saveInUrl?: boolean
  onSubmit?: () => void
}

interface FiltersFieldProps {
  value: SelectionFilterField[]
  items: Array<SimpleFilterField | DatepickerFilterField>
  onChangeValue: (value: SelectionFilterField[]) => void
  saveInUrl?: boolean
  onSubmit?: () => void
}

export { FiltersFieldSearchMode }

export type {
  FiltersFieldInstance,
  DatepickerFilterField,
  SelectionFilterField,
  SimpleFilterField,
  SimpleFilterFieldInstance,
  SortFieldValue,
  SortFieldItem,
  SortFieldProps,
  FiltersFieldProps,
  ControlBarInstance,
}
